<script>
    import * as Utils from '@js/modules/utils';
    import I18n from '@js/modules/translations';

    import SearchManager from '@js/managers/searchManager';

    import Autocompletion from '@js/components/search/Autocompletion.svelte';
    import SearchRideFilters from '@js/components/search/filter/SearchRideFilters.svelte';
    import SearchResultList from '@js/components/search/result/SearchResultList.svelte';
    import SearchMap from '@js/components/maps/SearchMap.svelte';
    import SearchRecommendation from '@js/components/search/SearchRecommendation.svelte';

    let activeFilters;

    let searchValue = $state({value: ''});

    const {
        allFilters
    } = $props();

    Utils.onPageReady(() => import(/* webpackChunkName: "maps-search" */ '@js/modules/maps/searchMap'), 20);

    SearchManager.initialize((searchParams) => {
        searchValue.value = searchParams.queryDisplay || searchParams.query;
    });

    const _performSearch = () => {
        const filters = {};
        if (Utils.isPresent(activeFilters)) {
            Object.entries(activeFilters)
                .forEach(([filterName, filterValue]) => {
                    if (filterName && filterValue) {
                        filters[filterName] = Array.from(filterValue);
                    }
                });
        }

        if (searchValue.query || searchValue.value) {
            SearchManager.fetchSearch({
                type: searchValue.type,
                query: searchValue.query || searchValue.value,
                queryDisplay: searchValue.value,
                location: {
                    bbox: searchValue.bbox,
                    center: searchValue.center
                },
                filters
            })
                .then(() => {
                    setTimeout(() => Utils.scrollTo('map-global-search'), 100);
                });
        } else {
            SearchManager.clearSearch();
        }
    };

    const _onFilterChange = (newFilters) => {
        activeFilters = newFilters;

        _performSearch();
    };

    const _handleAutocompletionSubmit = (/* newQuery */) => {
        activeFilters = {};

        _performSearch();
    };
</script>

<h1 class="title-h1 my-6">
    {I18n.t('js.search.index.title')}
</h1>

<Autocompletion id="global-search"
                bind:searchValue={searchValue}
                placeholder={I18n.t('js.search.index.placeholder')}
                useFirstQueryOnEnter={false}
                onSubmit={_handleAutocompletionSubmit}/>

<SearchRideFilters allFilters={allFilters}
                   onFilterUpdate={_onFilterChange}/>

<div class="mx-2">
    <div class="row">
        <div class="col s12 l7 xl8 search-result-map-container">
            <SearchMap mapId="advanced-search"/>
        </div>

        <div class="col s12 l5 xl4 relative mt-8 md:mt-0">
            <SearchResultList/>
        </div>
    </div>
</div>

<SearchRecommendation/>
